import React, { FC } from 'react';
import { View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { ContainerStyle } from '@interfaces/base';
import { DashboardResultType } from '@api/domain/types';
import type { DashboardScope, DashboardDrilldownFilter } from '@api/domain/types';
import DashboardLegend from '@v2/pages/dashboard/common/components/DashboardLegend';
import DashboardList from '@v2/pages/dashboard/common/components/DashboardList';
import DashboardSummary from '@v2/pages/dashboard/common/components/DashboardSummary';

import { useManageDashboardDrilldownList } from './hooks/useManageDashboardDrilldownList';

export interface DashboardDrilldownListProps extends WithColor, ContainerStyle {
  childScope: DashboardScope;
  drilldownFilter: DashboardDrilldownFilter;
}

const DashboardDrilldownList: FC<DashboardDrilldownListProps> = ({ childScope, drilldownFilter, containerStyle }) => {
  const { resultType, orderBy, from, to, pageNumber, overall, overallLoading, list } = useManageDashboardDrilldownList({
    childScope,
    drilldownFilter,
  });

  const isDiverging = resultType !== DashboardResultType.Actual;

  return (
    <View style={[{ flex: 1, gap: scale(8) }, containerStyle]}>
      {isDiverging && <DashboardLegend />}
      <DashboardList
        scope={childScope}
        resultType={resultType}
        orderBy={orderBy}
        from={from}
        to={to}
        items={list.items}
        loading={list.loading}
        error={list.error}
        pageNumber={pageNumber}
        onLoadMore={list.loadNext}
        onRetry={list.refetch}
        containerStyle={{ flex: 1 }}
      />
      {isDiverging && (
        <DashboardSummary overall={overall ?? null} loading={overallLoading} containerStyle={{ marginTop: scale(8), marginBottom: scale(16) }} />
      )}
    </View>
  );
};

export default ColorWrapper(DashboardDrilldownList);
